(function () {
  'use strict';

  // ── Menú móvil — hamburguesa ─────────────────────────────────────────────
  function initMobileNavigation() {
    var toggle = document.getElementById('navToggle');
    var menu = document.getElementById('navMenu');

    if (!toggle || !menu) return;

    var body = document.body;
    var breakpoint = window.matchMedia('(min-width: 768px)');

    function abrirMenu() {
      body.classList.add('is-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Cerrar menú');
    }

    function cerrarMenu() {
      body.classList.remove('is-nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir menú');
    }

    function alternarMenu() {
      if (body.classList.contains('is-nav-open')) {
        cerrarMenu();
      } else {
        abrirMenu();
      }
    }

    toggle.addEventListener('click', alternarMenu);

    menu.addEventListener('click', function (evento) {
      var enlace = evento.target.closest('a');
      if (!enlace) return;

      cerrarMenu();
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && body.classList.contains('is-nav-open')) {
        cerrarMenu();
        toggle.focus();
      }
    });

    function revisarBreakpoint(evento) {
      if (evento.matches) {
        cerrarMenu();
      }
    }

    if (typeof breakpoint.addEventListener === 'function') {
      breakpoint.addEventListener('change', revisarBreakpoint);
    } else {
      breakpoint.addListener(revisarBreakpoint);
    }
  }

  function initCitasForm() {
    var form = document.getElementById('citas-form');
    if (!form) return;

    var numero = form.dataset.whatsapp;

    form.addEventListener('submit', function (evento) {
      evento.preventDefault();

      var nombre = (document.getElementById('citas-nombre').value || '').trim();
      var motivoSelect = document.getElementById('citas-motivo-tipo');
      var opcion = motivoSelect.options[motivoSelect.selectedIndex]
        ? motivoSelect.options[motivoSelect.selectedIndex].text
        : '';
      var consulta = (document.getElementById('citas-consulta').value || '').trim();

      var mensaje = 'Hola.\n\n'
        + 'Mi nombre es ' + nombre + '.\n\n'
        + '¿Cómo podemos ayudarte?\n'
        + opcion + '\n\n'
        + 'Motivo de consulta:\n'
        + consulta + '\n\n'
        + 'Me gustaría recibir información.\n\n'
        + 'Gracias.';

      var url = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensaje);

      window.open(url, '_blank', 'noopener,noreferrer');
    });
  }

  // ── Hero principal — GSAP ────────────────────────────────────────────────
  function initHomeHeroAnimations(reduceMotion) {
    var hero = document.querySelector('.home-hero');

    if (!hero || typeof gsap === 'undefined' || reduceMotion) {
      return;
    }

    var heroImg = hero.querySelector('.home-hero__image');
    var title = hero.querySelector('.home-hero__title');
    var text = hero.querySelector('.home-hero__text');
    var actions = hero.querySelector('.home-hero__actions');
    var features = hero.querySelectorAll('.home-hero__feature');

    var tl = gsap.timeline();

    if (heroImg) {
      gsap.set(heroImg, { scale: 1.04 });
      tl.to(heroImg, { scale: 1, duration: 1.6, ease: 'power2.out' }, 0);
    }

    if (title) {
      gsap.set(title, { autoAlpha: 0, y: 22 });
      tl.to(title, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out' }, 0.1);
    }

    if (text) {
      gsap.set(text, { autoAlpha: 0, y: 22 });
      tl.to(text, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out' }, 0.28);
    }

    if (actions) {
      gsap.set(actions, { autoAlpha: 0, y: 16 });
      tl.to(actions, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power3.out' }, 0.42);
    }

    if (features.length) {
      gsap.set(features, { autoAlpha: 0, y: 14 });
      tl.to(features, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.09 }, 0.55);
    }
  }

  // ── Introducción clínica — GSAP + ScrollTrigger ──────────────────────────
  function initHomeIntroAnimations(reduceMotion) {
    var section = document.querySelector('.home-intro');

    if (!section || typeof gsap === 'undefined' || reduceMotion) {
      return;
    }

    var scrollTriggerReady = typeof ScrollTrigger !== 'undefined';

    if (scrollTriggerReady) {
      gsap.registerPlugin(ScrollTrigger);
    }

    var mm = gsap.matchMedia();

    // gsap.matchMedia limpia automáticamente tweens/ScrollTriggers de este
    // contexto al cruzar el breakpoint (sin saltos al rotar/redimensionar).
    mm.add(
      {
        isDesktop: '(min-width: 768px)',
        isMobile: '(max-width: 767px)'
      },
      function (context) {
        var isDesktop = !!context.conditions.isDesktop;
        var image = section.querySelector('.home-intro__image');
        var content = section.querySelector('.home-intro__content');

        // Parallax mínimo — solo escritorio/tablet, solo con ScrollTrigger disponible
        //
        // La escala de margen (buffer) se fija AQUÍ, con gsap.set, en vez de en
        // SCSS. GSAP reconstruye la propiedad transform completa a partir de su
        // propio caché interno (x/y/scale/rotation); un transform:scale() puesto
        // solo por CSS no forma parte de ese caché, así que en cuanto gsap.to()
        // toca la propiedad transform lo descarta y la imagen queda a scale:1
        // mientras se desplaza — eso producía la franja. Fijando el scale con
        // GSAP, ambos valores viven en el mismo motor y nunca se pisan.
        if (isDesktop && image && scrollTriggerReady) {
          gsap.set(image, { scale: 1.08, transformOrigin: '50% 50%' });

          gsap.to(image, {
            yPercent: 3,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1
            }
          });
        }

        if (!content) {
          return;
        }

        // eyebrow/titulo viven en .home-intro__heading (columna 1), no dentro
        // de .home-intro__content (columna 2) — se buscan en toda la sección.
        var eyebrow = section.querySelector('.eyebrow');
        var titulo = section.querySelector('.home-intro__title');
        var texto = content.querySelector('.home-intro__text');
        var items = content.querySelectorAll('.home-intro__list li');

        var axis = isDesktop ? 'x' : 'y';
        var distLarge = isDesktop ? 24 : 14;
        var distSmall = isDesktop ? 16 : 12;

        var tl = gsap.timeline(
          scrollTriggerReady
            ? { scrollTrigger: { trigger: content, start: 'top 75%'} }
            : {}
        );

        if (eyebrow) {
          var eyebrowFrom = { autoAlpha: 0 };
          eyebrowFrom[axis] = distSmall;
          gsap.set(eyebrow, eyebrowFrom);
          tl.to(eyebrow, { autoAlpha: 1, x: 0, y: 0, duration: 0.4, ease: 'power2.out' }, 0);
        }

        if (titulo) {
          var tituloFrom = { autoAlpha: 0 };
          tituloFrom[axis] = distLarge;
          gsap.set(titulo, tituloFrom);
          tl.to(titulo, { autoAlpha: 1, x: 0, y: 0, duration: isDesktop ? 0.6 : 0.45, ease: 'power2.out' }, 0.08);
        }

        if (texto) {
          var textoFrom = { autoAlpha: 0 };
          textoFrom[axis] = distLarge;
          gsap.set(texto, textoFrom);
          tl.to(texto, { autoAlpha: 1, x: 0, y: 0, duration: isDesktop ? 0.55 : 0.5, ease: 'power2.out' }, 0.18);
        }

        if (items.length) {
          var itemsFrom = { autoAlpha: 0 };
          itemsFrom[axis] = distSmall;
          gsap.set(items, itemsFrom);
          tl.to(items, {
            autoAlpha: 1,
            x: 0,
            y: 0,
            duration: isDesktop ? 0.45 : 0.4,
            ease: 'power2.out',
            stagger: 0.08
          }, 0.28);
        }
      }
    );
  }

  // ── Heroes editoriales — GSAP genérico para Nosotros, Servicios, EMT, EEG, etc
  function initEditorialHeroAnimations(reduceMotion) {
    var heroes = document.querySelectorAll('.hero-interior.hero-interior--editorial');

    if (!heroes.length || typeof gsap === 'undefined' || reduceMotion) {
      return;
    }

    heroes.forEach(function (hero) {
      var image = hero.querySelector('.hero-interior__media img');
      var breadcrumb = hero.querySelector('.breadcrumb--hero');
      var content = hero.querySelector('.hero-interior__content');

      if (!content) {
        return;
      }

      var eyebrow = content.querySelector('.eyebrow');
      var title = content.querySelector('.hero-interior__title');
      var text = content.querySelector('.hero-interior__text');
      var actions = content.querySelector('.hero-interior__actions');

      var tl = gsap.timeline();

      // Imagen: zoom suave
      if (image) {
        gsap.set(image, { scale: 1.04, transformOrigin: '50% 50%' });
        tl.to(image, { scale: 1, duration: 1.6, ease: 'power2.out' }, 0);
      }

      // Breadcrumb: fade-in + desplazamiento suave hacia arriba
      if (breadcrumb) {
        gsap.set(breadcrumb, { autoAlpha: 0, y: -8 });
        tl.to(breadcrumb, { autoAlpha: 1, y: 0, duration: 0.4, ease: 'power2.out' }, 0.05);
      }

      // Eyebrow: fade-in + desplazamiento suave hacia abajo
      if (eyebrow) {
        gsap.set(eyebrow, { autoAlpha: 0, y: 12 });
        tl.to(eyebrow, { autoAlpha: 1, y: 0, duration: 0.45, ease: 'power2.out' }, 0.12);
      }

      // Título: fade-in + desplazamiento suave hacia abajo
      if (title) {
        gsap.set(title, { autoAlpha: 0, y: 22 });
        tl.to(title, { autoAlpha: 1, y: 0, duration: 0.75, ease: 'power3.out' }, 0.2);
      }

      // Párrafo: fade-in + desplazamiento suave hacia abajo
      if (text) {
        gsap.set(text, { autoAlpha: 0, y: 18 });
        tl.to(text, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out' }, 0.36);
      }

      // Botones: fade-in + desplazamiento suave hacia abajo
      if (actions) {
        gsap.set(actions, { autoAlpha: 0, y: 14 });
        tl.to(actions, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power2.out' }, 0.5);
      }

      // Contenido adicional: párrafos o listas después de los botones
      var additionalElements = [];
      var childNodes = content.children;

      for (var i = 0; i < childNodes.length; i++) {
        var child = childNodes[i];
        if (
          child !== eyebrow &&
          child !== title &&
          child !== text &&
          child !== actions &&
          (child.tagName.toLowerCase() === 'p' || child.tagName.toLowerCase() === 'ul')
        ) {
          additionalElements.push(child);
        }
      }

      // Animar contenido adicional
      if (additionalElements.length) {
        additionalElements.forEach(function (element) {
          if (element.tagName.toLowerCase() === 'ul') {
            // Si es una lista, animar sus elementos internos con stagger
            var listItems = element.querySelectorAll('li');
            if (listItems.length) {
              gsap.set(listItems, { autoAlpha: 0, y: 12 });
              tl.to(listItems, {
                autoAlpha: 1,
                y: 0,
                duration: 0.5,
                ease: 'power2.out',
                stagger: 0.07
              }, 0.62);
            } else {
              // Si la lista no tiene items explícitos, animar el contenedor
              gsap.set(element, { autoAlpha: 0, y: 12 });
              tl.to(element, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' }, 0.62);
            }
          } else {
            // Si es un párrafo u otro elemento, animar normalmente
            gsap.set(element, { autoAlpha: 0, y: 12 });
            tl.to(element, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' }, 0.62);
          }
        });
      }
    });
  }

  // ── Reconocimiento del paciente — AOS ────────────────────────────────────
  function initAOS(reduceMotion) {
    if (reduceMotion || typeof AOS === 'undefined') {
      return;
    }

    AOS.init({
      duration: 650,
      easing: 'ease-out-cubic',
        offset: 80,
      disable: function () {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    initMobileNavigation();
    initCitasForm();
    initHomeHeroAnimations(reduceMotion);
    initEditorialHeroAnimations(reduceMotion);
    initHomeIntroAnimations(reduceMotion);
    initAOS(reduceMotion);
  });
})();
